import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6909855b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box_img"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bottom_text"
}, " 图片仅支持jpg/jpeg/png格式，宽度 390px，高度 自适应。 文件大小不能超过2M ", -1));
import { reactive, watch, nextTick } from "vue";
import separateUpload from "@/components/separate-upload.vue";
import { addSecondDoctorDepApi } from "@/service/modules/case";
export default /*#__PURE__*/_defineComponent({
  __name: 'dept-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    itemData: {
      type: Object,
      default: () => {}
    }
  },
  emits: ["closeDialog"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const form = reactive({
      id: "",
      name: "",
      banner: ""
    });
    const emit = __emit;
    function closeDialog() {
      console.log("关闭钱");
      emit("closeDialog");
    }
    watch(() => props.dialogVisible, newValue => {
      if (newValue) {
        nextTick(() => {
          for (let key in form) {
            console.log(key, props.itemData[key]);
            form[key] = props.itemData[key];
          }
        });
      }
    });
    function imgTypeError() {
      console.log("图片类型错误");
    }
    function deleteImg() {
      form.banner = "";
    }
    async function handleSettingsumbit() {
      if (form.id == "") {
        return;
      }
      let res = await addSecondDoctorDepApi(form);
      if (res.code == 0) {
        closeDialog();
      }
    }
    function handleRemove() {
      console.log("取消");
      closeDialog();
    }
    function imgLoadSuccess(img) {
      console.log("图片加载成功", img);
      form.banner = img;
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_CloseBold = _resolveComponent("CloseBold");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: "编辑图片",
        width: "25%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref: "formRef",
          model: form,
          "label-width": "80px",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "ID",
            prop: "id"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              class: "input_w",
              modelValue: form.id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.id = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "科室",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              class: "input_w",
              modelValue: form.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.name = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "图片",
            prop: "banner"
          }, {
            default: _withCtx(() => [_createVNode(separateUpload, {
              maxSize: 2,
              accept: ".jpg, .png, .jpeg",
              "file-types": ['image/png', 'image/jpeg'],
              onTypeError: imgTypeError,
              onUploadSuccess: imgLoadSuccess
            }), _createElementVNode("div", _hoisted_1, [form.banner ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "preview-img",
              src: form.banner
            }, null, 8, _hoisted_2)) : _createCommentVNode("", true), _createElementVNode("i", {
              class: "i_icon",
              onClick: deleteImg
            }, [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_component_CloseBold)]),
              _: 1
            })])]), _hoisted_3]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            class: "footer"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: handleSettingsumbit
            }, {
              default: _withCtx(() => [_createTextVNode(" 确定 ")]),
              _: 1
            }), _createVNode(_component_el_button, {
              type: "danger",
              onClick: handleRemove
            }, {
              default: _withCtx(() => [_createTextVNode(" 取消 ")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["model-value"])]);
    };
  }
});